// extracted by mini-css-extract-plugin
export default {"appHeader":"SharedHeader_appHeader__06Yb5","appHeaderContainer":"SharedHeader_appHeaderContainer__D-jwI","iconWrapper":"SharedHeader_iconWrapper__SzRha"};